/**
 * Zentrale Anmelde-Weitergabe für ALLE fetch-Aufrufe.
 *
 * Warum es das gibt: Bis Welle 58 hing die Anmeldung an einzelnen Aufrufen —
 * von 281 fetch-Stellen schickten nur 8 den `x-ma-token`-Header mit. Der Rest
 * ging ohne Anmeldung durch, was nur deshalb „funktionierte", weil das Backend
 * gar nichts prüfte (siehe Sicherheits-Audit). Sobald das Backend die
 * Anmeldung verlangt, müssten sonst 273 Stellen von Hand nachgezogen werden —
 * fehleranfällig, und die nächste vergessene Stelle wäre sofort ein 401.
 *
 * Stattdessen wird `window.fetch` EINMAL beim App-Start umschlossen: Jeder
 * Aufruf an das eigene Backend bekommt den Token automatisch. Externe Ziele
 * (falls je welche dazukommen) bleiben unberührt — der Token darf niemals an
 * einen fremden Host gehen.
 *
 * Header-basiert und nicht per Cookie: Ein Header kann von einer fremden
 * Website nicht gesetzt werden, deshalb ist dieser Weg von sich aus gegen
 * CSRF immun. Ein Cookie würde der Browser auch bei fremd ausgelösten
 * Requests mitschicken.
 */
import { API_BASE } from "./config";

let installiert = false;

/** Gehört die URL zum eigenen Backend? Nur dann den Token anhängen. */
function istEigenesBackend(url) {
  if (typeof url !== "string") return false;
  // Relativ (gleicher Ursprung) — z. B. "/skripte/api/liste"
  if (url.startsWith("/") && !url.startsWith("//")) return true;
  // Absolut auf die konfigurierte Backend-Basis
  if (API_BASE && url.startsWith(API_BASE)) return true;
  // Absolut, aber auf denselben Ursprung wie die Seite
  try {
    if (typeof window !== "undefined" && window.location) {
      return new URL(url, window.location.origin).origin === window.location.origin;
    }
  } catch (_) {}
  return false;
}

export function installAuthFetch() {
  if (installiert || typeof window === "undefined" || !window.fetch) return;
  installiert = true;
  const origFetch = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    // input kann ein String, eine URL oder ein Request-Objekt sein.
    const url =
      typeof input === "string" ? input
      : input instanceof URL ? input.toString()
      : (input && input.url) || "";

    if (!istEigenesBackend(url)) {
      return origFetch(input, init);
    }

    const token = (() => {
      try { return localStorage.getItem("maToken"); } catch (_) { return null; }
    })();
    if (!token) return origFetch(input, init);

    // Vorhandene Header respektieren — setzt jemand den Token schon selbst,
    // bleibt er stehen. Headers kann Objekt, Array oder Headers-Instanz sein.
    const h = new Headers(
      (init && init.headers) ||
      (input && input.headers) ||
      {}
    );
    if (!h.has("x-ma-token")) h.set("x-ma-token", token);

    return origFetch(input, { ...init, headers: h });
  };
}
